import { render, staticRenderFns } from "./host-common-posterAdd.vue?vue&type=template&id=515b5832&scoped=true&"
import script from "./host-common-posterAdd.vue?vue&type=script&lang=js&"
export * from "./host-common-posterAdd.vue?vue&type=script&lang=js&"
import style0 from "./host-common-posterAdd.vue?vue&type=style&index=0&id=515b5832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b5832",
  null
  
)

export default component.exports